import styled, { createGlobalStyle, keyframes } from "styled-components";
import { FontWeights, getTheme, mergeStyleSets, ILabelStyles, IButtonStyles } from "@fluentui/react";
import { IdentityRole } from "@/screen/Identities/Interfaces/IdentitiesMainScreenInterfaces";

// Global Styles
export const HelperStyle = createGlobalStyle`
    *,
    ::after,
    ::before
    {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    } 
    ul
    {
        list-style-type: none;
    }
    a
    {
        text-decoration: none;
    } 
`;

// Styled Components
export const Cont = styled.div`
    grid-area: main;
    background-color: ${(props) => props.theme.palette.white};
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;

export const MainCont = styled.div`
    padding: 20px 55px 40px 55px;
    hr
    {
        margin: 20px 0;
        border: solid 1px #eff4f6;
    }

    @media screen and (max-width: 599px)
    {
        padding: 20px 25px 40px 25px;
    }

    @media screen and (max-width: 420px)
    {
        padding: 20px 8px 40px 8px;
    }
`;

export const Title = styled.div`
    margin-top: 10px;
    cursor: default;
    h1
    {
        font-size: 30px;
        color: #2a4143;
        font-weight: 800;
        cursor: inherit;
    }
`;

export const TitleSubtitleRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 5px;
    flex-wrap: wrap;

    h2
    {
        font-size: 24px;
        font-weight: 400;
        color: #5f7172;
        margin: 0;
        flex: 1 1 0;
        min-width: min(100%, 240px);
        cursor: inherit;
    }

    @media screen and (max-width: 599px)
    {
        flex-direction: column;
        align-items: stretch;

        h2
        {
            min-width: unset;
        }

        > *:last-child
        {
            align-self: flex-end;
        }
    }
`;

export const BarCont = styled.div`
    width: 100%;
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const BgBar = styled.hr`
    width: 100%;
    border: solid 6px #fae9ed;
    border-radius: 10px;
    margin: 0;
`;

export const ProsBar = styled.hr`
    width: calc(100% - 8.33%);
    border: solid 4px #cc214f;
    border-radius: 10px;
    margin: -8px 0 0 0;
`;

export const RoleFilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    width: 100%;
`;

/** Pestañas por tipología (personas físicas, empresas, representantes); el filtro de rol queda a la derecha. */
export const PersonTypePivotWrap = styled.div`
    flex: 1 1 auto;

    .ms-Pivot-text
    {
        font-weight: 600;
    }
`;

/** Banner del modo contrato en Gestión de Intervinientes. */
export const ContractModeBanner = styled.div`
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 4px;
    border-left: 4px solid #1565c0;
    background-color: rgba(21, 101, 192, 0.08);
    color: #1565c0;
`;

export const ContractModeBannerRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

export const ContractModeBannerText = styled.span`
    flex: 1 1 auto;
    min-width: 200px;
    font-size: 14px;
    line-height: 1.4;
    cursor: default;
`;

export const ContractModeBannerActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin-left: auto;
`;

export const TabletCont = styled.div`
    background: ${(props) => props.theme.palette.tertiary};
    width: 100%;
    padding: 25px;
    border-radius: 20px;

    .status
    {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .actions
    {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    @media screen and (max-width: 420px)
    {
        padding: 35px 5px 30px 5px;
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    table-layout: fixed;
    cursor: default;

    thead tr
    {
        border-bottom: 2px solid #e9eff2;
    }

    tbody tr
    {
        border-bottom: 1px solid #e9eff2;

        &:last-of-type
        {
            border-bottom: none;
        }
    }

    th
    {
        padding: 15px 10px;
        font-size: 14px;
        font-weight: 600;
        color: #2a4143;

        &.tight
        {
            text-align: center;
            width: 100px;
        }

        &.wide
        {
            width: 20%;
        }
    }

    td
    {
        padding: 15px 10px;
        word-break: break-word;
        color: #5f7172;

        &.text-center
        {
            text-align: center;
        }
    }
`;

export const BtnCont = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 80px;

    @media screen and (max-width: 599px)
    {
        justify-content: center;
        flex-flow: row wrap;
        margin-top: 40px;

        a
        {
            margin: 0 10px;
        }

        button
        {
            margin-bottom: 20px;
        }
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .add-buttons
    {
        display: flex;
        gap: 10px;
    }

    .special-buttons
    {
        display: flex;
        align-items: center;
        gap: 10px;

        p
        {
            margin: 0;
            color: #5f7172;
            font-size: 14px;
        }
    }

    @media screen and (max-width: 899px)
    {
        flex-direction: column;
        gap: 20px;

        .add-buttons,
        .special-buttons
        {
            flex-direction: column;
            width: 100%;
        }
    }
`;

export const RoleBadge = styled.span<{ role: IdentityRole }>`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    background-color: ${(props) => props.role === "Owner" ? "#e8f5e9" : "#fff3e0"};
    color: ${(props) => props.role === "Owner" ? "#2e7d32" : "#ef6c00"};
`;

// Etiqueta de estado de un interviniente recibido por cesión y pendiente de aceptar (TRANSFER).
export const PendingTransferBadge = styled.span`
    display: inline-block;
    margin-top: 4px;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    background-color: #fff3e0;
    color: #ef6c00;
    cursor: pointer;
`;

export const SavingsPlansLink = styled.span`
    color: #CC214F;
    cursor: pointer;
    text-decoration: underline;

    &:hover
    {
        color: #a01a3f;
    }
`;

export const SavingsPlanTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
    cursor: default;

    th, td
    {
        padding: 12px;
        text-align: center;
        border-bottom: 1px solid #e9eff2;
    }

    th
    {
        color: #2a4143;
        font-weight: 600;
        background-color: #f5f7f9;
    }

    td
    {
        color: #5f7172;
    }
`;

// Modal Styles (Fluent UI)
const theme = getTheme();

export const contentStyles = mergeStyleSets(
{
    container:
    {
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "stretch",
        borderRadius: "2em",
        minWidth: "500px !important",
        maxWidth: "700px"
    },
    header:
    [
        theme.fonts.xLargePlus,
        {
            flex: "1 1 auto",
            color: "#CC214F",
            display: "flex",
            alignItems: "center",
            fontWeight: FontWeights.semibold,
            padding: "12px 12px 14px 24px"
        }
    ],
    body:
    {
        textAlign: "center",
        flex: "4 4 auto",
        padding: "0 24px 0 24px",
        overflowY: "auto",
        maxHeight: "400px",
        cursor: "default"
    }
});

export const styleLabel: Partial<ILabelStyles> =
{
    root:
    {
        fontSize: "19px !important",
        padding: "0 45px",
        margin: "0",
        textAlign: "center",
        width: "100%"
    }
};

export const styleDefButton: Partial<IButtonStyles> =
{
    root:
    {
        marginLeft: "1em",
        marginTop: "0.75em",
        cursor: "pointer",
        background: "#CC214F",
        fontFamily: "Barlow",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#FFFFFF",
        borderRadius: "100px",
        padding: "0.5em 1.5em",
        borderStyle: "none"
    }
};

export const styleCancelButton: Partial<IButtonStyles> =
{
    root:
    {
        marginTop: "0.75em",
        cursor: "pointer",
        background: "transparent",
        fontFamily: "Barlow",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#CC214F",
        borderRadius: "100px",
        padding: "0.5em 1.5em",
        border: "2px solid #CC214F"
    }
};
// Icono de "Firmar KYC" en la columna Acciones (solo intervinientes OUTDATED). Late de #CC214F a un
// rojo más vivo (#FF0000) para llamar la atención sobre la acción pendiente de firma. Solo CSS.
const kycSignPulse = keyframes`
    0%, 100% { color: #CC214F; }
    50% { color: #FF0000; transform: scale(1.12); }
`;

export const SignKycIcon = styled.i`
    cursor: pointer;
    font-size: 17px;
    padding-top: 3%;
    color: #CC214F;
    display: inline-block;
    transform-origin: center;
    animation: ${kycSignPulse} 1.2s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce)
    {
        animation: none;
        color: #FF0000;
    }
`;
